import templateUrl from "emun.report/job-scheduler/job-scheduler.htm";
import controller from "emun.report/job-scheduler/job-scheduler.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};